import digitalData from 'digital-data';
import {
  BUTTON_SUBMISSION,
  MY_ACCOUNT_SETTINGS,
  OVERLAY
} from '../constants';

const REFRESH_QUOTE_AND_UPDATE_PRICING = 'refresh quote and update pricing';
const REFRESH_QUOTE = 'quote refresh';
const EXIT_OVERLAY = 'refresh quote and update pricing overlay: exit';

/**
 * Helper function to ensure digitalData.event exists and add an event to it
 * @param {Object} event - The event to add to digitalData.event
 * @returns {void}
 */
const addAnalyticsEvent = (event) => {
  digitalData.event = digitalData.event || [];
  digitalData.event.push(event);
};

/**
 * Listener for quote refresh events
 * @returns {void}
 */
export const quoteRefresh = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('quote-refresh.landOnOverlay', () => {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: REFRESH_QUOTE_AND_UPDATE_PRICING
      }
    };

    addAnalyticsEvent(thdAnalyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('quote-refresh.exitOverlay', () => {
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: EXIT_OVERLAY
      }
    };

    addAnalyticsEvent(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('quote-refresh.success', (inputData) => {
    let quoteId = '';
    let quoteType = '';
    let myAccount = '';

    // Handle both production and test data structures
    // Production: inputData.output.output.{property} OR inputData.output.output.output.{property}
    // Test: inputData.output.{property}
    // Extract data from potentially nested structures using optional chaining
    const dataOutput = inputData?.output?.output?.output
     || inputData?.output?.output
     || inputData?.output || {};

    quoteId = dataOutput.quoteId || '';
    quoteType = dataOutput.quoteType || '';
    myAccount = dataOutput.myAccount || '';

    const thdAnalyticsEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: REFRESH_QUOTE
      },
      quoteType,
      quoteId,
      myAccount
    };

    addAnalyticsEvent(thdAnalyticsEvent);
  });
};

export default quoteRefresh;
